import { lessonConstants } from "../constants/lessonConstants"
import { rulesConstants } from "../constants/rulesConstants"

const initialState = {
  lesson: {},
  lessons: [],
  lessonDecks: [],
  lessonDeckBank: {},
  allDeckLogics: [],
  deckLogics: {},
  deckBanks: [],
  section: {},
  subcourse: {},
  course: {},
  decks: {},
  subcourses: null,
  sections: null,
  lessonRules: null,
  isFetching_subcourses: false,
  isFetching_sections: false,
  fetching_parents_failure: null,
  fetching_Selected_lesson: false,
  isMovingLesson: false,
  isPublishing: false,
  publishError: null,
  moveLessonFailure: null,
  getLessonFailure: null,
  isChangingDisplayName: false,
  isChangingName: false,
  nameChangesFailure: null,
  isDeletingLesson: false,
  lessonDeleted: false,
  isChangingVideoLink: false,
  setNode: false,
  setNodeFailed: null,
  editingDeckLogic: false,
  allSections: [],
  allSubcourses: [],
  allCourses: [],
  allItemBanks: [],
  updatedItemBanks: [],
  lessonItemBank: {},
  lessonItems: [],
  isChangingDesc: false,
  isChangingAllotedTime: false
}

export function lessonReducers(state = initialState, action) {
  switch (action.type) {
    case lessonConstants.FETCH_ALL_LESSON_REQUEST:
      return {
        ...state,
        fetching_all_lessons: true
      }
    case lessonConstants.FETCH_ALL_LESSON_FAILURE:
      return {
        ...state,
        fetching_lessons_error: action.error,
        fetching_all_lessons: false
      }
    case lessonConstants.FETCH_ALL_LESSON_SUCCESS:
      return {
        ...state,
        lessons: action.lessons,
        fetching_all_lessons: false
      }
    case lessonConstants.FETCH_SELECTED_LESSON:
      return {
        ...state,
        fetching_Selected_lesson: true,
        getLessonFailure: null
      }

    case lessonConstants.SELECTED_LESSON_FAILURE:
      return {
        ...state,
        fetching_Selected_lesson: false,
        getLessonFailure: action.error
      }

    case lessonConstants.SELECTED_LESSON_SUCCESS:
      return {
        ...state,
        fetching_Selected_lesson: false,
        lesson: action.data.lesson,
        section: action.data.section,
        course: action.data.course,
        subcourse: action.data.subcourse,
        lessonRules: action.data.lessonRules
      }

    case lessonConstants.FETCHING_SUBCOURSES:
      return {
        ...state,
        isFetching_subcourses: true
      }
    case lessonConstants.FETCHING_SUBCOURSES_FAILED:
      return {
        ...state,
        isFetching_subcourses: false,
        fetching_parents_failure: action.error
      }

    case lessonConstants.FETCHING_SUBCOURSES_SUCCESS:
      return {
        ...state,
        isFetching_subcourses: false,
        subcourses: action.parents.subcourses
      }

    case lessonConstants.FETCHING_SECTIONS:
      return {
        ...state,
        isFetching_sections: true
      }
    case lessonConstants.FETCHING_SECTIONS_FAILED:
      return {
        ...state,
        isFetching_sections: false,
        fetching_parents_failure: action.error
      }

    case lessonConstants.FETCHING_SECTIONS_SUCCESS:
      return {
        ...state,
        isFetching_sections: false,
        sections: action.parents.sections
      }

    case lessonConstants.MOVING_LESSON:
      return {
        ...state,
        isMovingLesson: true
      }

    case lessonConstants.MOVE_LESSON_SUCCESS:
      return {
        ...state,
        isMovingLesson: false,
        lesson: action.parents.lesson,
        section: action.parents.section,
        subcourse: action.parents.subcourse
      }

    case lessonConstants.MOVE_LESSON_FAILED:
      return {
        ...state,
        isMovingLesson: false,
        moveLessonFailure: action.error
      }

    case lessonConstants.CHANGE_PUBLISH_STATUS:
      return {
        ...state,
        isPublishing: true
      }

    case lessonConstants.CHANGE_PUBLISH_STATUS_SUCCESS:
      return {
        ...state,
        isPublishing: false,
        lesson: action.lesson
      }

    case lessonConstants.CHANGE_PUBLISH_STATUS_FAILED:
      return {
        ...state,
        isPublishing: false,
        publishError: action.error
      }

    case lessonConstants.DISPLAY_NAME_CHANGE:
      return {
        ...state,
        isChangingDisplayName: true
      }

    case lessonConstants.NAME_CHANGE:
      return {
        ...state,
        isChangingName: true
      }

    case lessonConstants.DISPLAY_NAME_CHANGE_SUCCESS:
      return {
        ...state,
        isChangingDisplayName: false,
        lesson: action.lesson
      }

    case lessonConstants.NAME_CHANGE_SUCCESS:
      return {
        ...state,
        isChangingName: false,
        lesson: action.lesson
      }

    case lessonConstants.NAME_CHANGES_FAILED:
      return {
        ...state,
        isChangingName: false,
        isChangingDisplayName: false,
        nameChangesFailure: action.error
      }

    case lessonConstants.DESCRIPTION_UPDATE:
      return {
        ...state,
        isChangingDesc: true
      }
    case lessonConstants.DESCRIPTION_UPDATE_SUCCESS:
      return {
        ...state,
        isChangingDesc: false,
        lesson: action.lesson
      }

    case lessonConstants.DESCRIPTION_UPDATE_FAILED:
      return {
        ...state,
        isChangingDesc: false,
        descChangesFailure: action.error
      }

    case lessonConstants.LESSON_ALLOTED_TIME_CHANGE:
      return {
        ...state,
        isChangingAllotedTime: true
      }
    case lessonConstants.LESSON_ALLOTED_TIME_CHANGE_SUCCESS:
      return {
        ...state,
        isChangingAllotedTime: false,
        lesson: action.lesson
      }

    case lessonConstants.LESSON_ALLOTED_TIME_CHANGE_FAILED:
      return {
        ...state,
        isChangingAllotedTime: false,
        allotedTimeFailure: action.error
      }

    case lessonConstants.LESSON_DELETE_REQUEST:
      return {
        ...state,
        isDeletingLesson: true
      }

    case lessonConstants.LESSON_DELETE_FAILURE:
      return {
        ...state,
        isDeletingLesson: false,
        deleteLessonFailed: action.error
      }

    case lessonConstants.LESSON_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingLesson: false,
        lessonDeleted: true
      }

    case lessonConstants.SET_NODE_REQUEST:
      return {
        ...state,
        setNode: true
      }

    case lessonConstants.SET_NODE_SUCCESS:
      return {
        ...state,
        setNode: false,
        lesson: action.lesson
      }

    case lessonConstants.SET_NODE_FAILURE:
      return {
        ...state,
        setNode: false,
        setNodeFailed: action.error
      }
    case lessonConstants.FETCHING_ALL_COURSES_REQUEST:
      return {
        ...state,
        fetchingAllCoursesFromDB: true
      }

    case lessonConstants.FETCHING_ALL_COURSES_SUCCESS:
      return {
        ...state,
        fetchingAllCoursesFromDB: false,
        allCourses: action.courses
      }

    case lessonConstants.FETCHING_ALL_COURSES_FAILURE:
      return {
        ...state,
        fetchingAllCoursesError: action.error,
        fetchingAllCoursesFromDB: false
      }

    case lessonConstants.FETCHING_ALL_SUBCOURSES_REQUEST:
      return {
        ...state,
        fetchingAllSubcoursesFromDB: true
      }

    case lessonConstants.FETCHING_ALL_SUBCOURSES_SUCCESS:
      return {
        ...state,
        fetchingAllSubcoursesFromDB: false,
        allSubcourses: action.subcourses
      }

    case lessonConstants.FETCHING_ALL_SUBCOURSES_FAILURE:
      return {
        ...state,
        fetchingAllSubcoursesError: action.error,
        fetchingAllSubcoursesFromDB: false
      }

    case lessonConstants.FETCHING_ALL_SECTIONS_REQUEST:
      return {
        ...state,
        fetchingAllSectionsFromDB: true
      }

    case lessonConstants.FETCHING_ALL_SECTIONS_SUCCESS:
      return {
        ...state,
        fetchingAllSectionsFromDB: false,
        allSections: action.sections
      }

    case lessonConstants.FETCHING_ALL_SECTIONS_FAILURE:
      return {
        ...state,
        fetchingAllSectionsError: action.error,
        fetchingAllSectionsFromDB: false
      }

    case lessonConstants.CREATE_DECK_BANK_FAILURE:
      return {
        ...state,
        creatingDeckBankError: action.error,
        creatingDeckBank: false
      }

    case lessonConstants.CREATE_DECK_BANK_SUCCESS:
      return {
        ...state,
        creatingDeckBank: false
      }

    case lessonConstants.CREATE_DECK_BANK_REQUEST:
      return {
        ...state,
        creatingDeckBank: true
      }

    case lessonConstants.FETCH_ALL_DECK_BANK_FAILURE:
      return {
        ...state,
        fetchingAllDeckBanks: false,
        fetchingDeckBanksError: action.error
      }

    case lessonConstants.FETCH_ALL_DECK_BANK_SUCCESS:
      return {
        ...state,
        deckBanks: action.deckBanks,
        fetchingAllDeckBanks: false
      }

    case lessonConstants.FETCH_ALL_DECK_BANK_REQUEST:
      return {
        ...state,
        fetchingAllDeckBanks: true
      }

    case lessonConstants.FETCH_LESSON_DECKS_REQUEST:
      return {
        ...state,
        fetchingDecks: true
      }

    case lessonConstants.FETCH_LESSON_DECKS_FAILURE:
      return {
        ...state,
        fetchingDecks: false,
        fetchingDecksError: action.error
      }

    case lessonConstants.FETCH_LESSON_DECKS_SUCCESS:
      return {
        ...state,
        fetchingDecks: false,
        lessonDecks: action.lessonDecks,
        lessonDeckBank: action.deckBankObj,
        deckLogics: action.deckBankObj.deckLogics
      }

    case lessonConstants.UPDATE_DECK_INDEX_REQUEST:
      return {
        ...state,
        updatingDeckIndex: true
      }

    case lessonConstants.UPDATE_DECK_INDEX_FAILURE:
      return {
        ...state,
        updatingDeckIndex: false,
        updatingDeckIndexError: action.error
      }

    case lessonConstants.UPDATE_DECK_INDEX_SUCCESS:
      return {
        ...state,
        updatingDeckIndex: false,
        lessonDeckBank: { ...state.lessonDeckBank, ...action.deckBankDecks }
      }
    case lessonConstants.ADD_DECK_REQUEST:
      return {
        ...state,
        addingDeck: true
      }

    case lessonConstants.ADD_DECK_FAILURE:
      return {
        ...state,
        addingDeck: false,
        addingDeckError: action.error
      }

    case lessonConstants.ADD_DECK_SUCCESS:
      let updatedDecks = state.lessonDecks
      action.decksData.forEach(deck => {
        if (
          state.lessonDeckBank &&
          state.lessonDeckBank.decks &&
          state.lessonDeckBank.decks[deck.id] === -1
        ) {
        } else {
          updatedDecks.push(deck)
        }
      })
      return {
        ...state,
        addingDeck: false,
        lessonDecks: updatedDecks,
        lessonDeckBank: {
          ...{
            cardsCount: action.cardsCount,
            decks: { ...state.lessonDeckBank.decks, ...action.deck }
          }
        }
      }
    case lessonConstants.DELETE_DECK_REQUEST:
      return {
        ...state,
        deletingDeck: true
      }

    case lessonConstants.DELETE_DECK_FAILURE:
      return {
        ...state,
        deletingDeck: false,
        deletingDeckError: action.error
      }

    case lessonConstants.DELETE_DECK_SUCCESS:
      let deletedDecks = state.lessonDecks
      return {
        ...state,
        addingDeck: false,
        lessonDecks: deletedDecks,
        lessonDeckBank: {
          ...{
            cardsCount: action.cardsCount,
            decks: { ...state.lessonDeckBank.decks, ...action.deck }
          }
        },
        deckLogics: action.deckLogics
      }

    case lessonConstants.DELETE_DECK_LOGIC_FROM_BANK_REQUEST:
      return {
        ...state,
        deletingDeckLogic: true
      }

    case lessonConstants.DELETE_DECK_LOGIC_FROM_BANK_FAILURE:
      return {
        ...state,
        deletingDeckLogic: false,
        deletingDeckLogicError: action.error
      }

    case lessonConstants.DELETE_DECK_LOGIC_FROM_BANK_SUCCESS:
      return {
        ...state,
        deletingDeckLogic: false,
        deckLogics: action.deckLogics
      }
    case lessonConstants.CREATE_DECK_LOGIC_REQUEST:
      return {
        ...state,
        creatingDeckLogic: true
      }

    case lessonConstants.CREATE_DECK_LOGIC_FAILURE:
      return {
        ...state,
        creatingDeckLogic: false,
        creatingDeckLogicError: action.error
      }

    case lessonConstants.CREATE_DECK_LOGIC_SUCCESS:
      return {
        ...state,
        creatingDeckLogic: false,
        deckLogics: { ...state.deckLogics, ...action.deckLogic }
      }

    case lessonConstants.FETCH_ALL_DECKLOGICS_REQUEST:
      return {
        ...state,
        fetchingAllDeckLogic: true
      }

    case lessonConstants.FETCH_ALL_DECKLOGICS_FAILURE:
      return {
        ...state,
        fetchingAllDeckLogic: false,
        fetchingAllDeckLogicError: action.error
      }

    case lessonConstants.FETCH_ALL_DECKLOGICS_SUCCESS:
      var deckLogics = state.allDeckLogics
      deckLogics.push(...action.deckLogics)

      return {
        ...state,
        fetchingAllDeckLogic: false,
        allDeckLogics: deckLogics //{...state.allDeckLogics,...action.deckLogics}
      }

    case lessonConstants.EDIT_DECK_LOGIC_REQUEST:
      return {
        ...state,
        editingDeckLogic: true
      }

    case lessonConstants.EDIT_DECK_LOGIC_FAILURE:
      return {
        ...state,
        editingDeckLogic: false,
        editingDeckLogicError: action.error
      }

    case lessonConstants.EDIT_DECK_LOGIC_SUCCESS:
      var deckLogics = state.allDeckLogics
      deckLogics.forEach(deckLogic => {
        if (deckLogic.id === action.deckLogic.id) {
          deckLogic.name = action.deckLogic.name
          deckLogic.directives = action.deckLogic.directives
          deckLogic.lastModified = action.deckLogic.lastModified
        }
      })

      return {
        ...state,
        editingDeckLogic: false,
        allDeckLogics: deckLogics //{...state.allDeckLogics,...action.deckLogics}
      }

    case lessonConstants.EDIT_DECK_BANK_LOGIC_REQUEST:
      return {
        ...state,
        editingDeckBankLogic: true
      }

    case lessonConstants.EDIT_DECK_BANK_LOGIC_FAILURE:
      return {
        ...state,
        editingDeckBankLogic: false,
        editingDeckBankLogicError: action.error
      }

    case lessonConstants.EDIT_DECK_BANK_LOGIC_SUCCESS:
      return {
        ...state,
        editingDeckLogic: false,
        deckLogics: action.deckLogic //{...state.allDeckLogics,...action.deckLogics}
      }

    case rulesConstants.ADD_LESSON_RULES_SUCCESS:
      return {
        ...state,
        lessonRules: action.change,
        lesson: { ...state.lesson, rules: action.change.id }
      }

    case rulesConstants.UPDATE_LESSON_RULES_SUCCESS:
    case rulesConstants.UPDATE_LESSON_RULE_SUCCESS:
    case rulesConstants.DELETE_LESSON_RULE_SUCCESS:
      return {
        ...state,
        lessonRules: action.change
      }

    case lessonConstants.FETCHING_ALL_ITEM_BANKS:
      return {
        ...state,
        fetchingAllItemBanksFromDB: true
      }

    case lessonConstants.FETCHING_ALL_ITEM_BANKS_SUCCESS:
      return {
        ...state,
        fetchingAllItemBanksFromDB: false,
        allItemBanks: action.itemBanks
      }

    case lessonConstants.FETCHING_ALL_ITEM_BANKS_FAILURE:
      return {
        ...state,
        fetchingAllItemBanksError: action.error,
        fetchingAllItemBanksFromDB: false
      }

    case lessonConstants.UPDATE_ITEM_BANKS_REQUEST:
      return {
        ...state,
        isUpdatingItemBanks: true
      }

    case lessonConstants.UPDATE_ITEM_BANKS_SUCCESS:
      return {
        ...state,
        isUpdatingItemBanks: false,
        updatedItemBanks: action.updatedItemBanks
      }

    case lessonConstants.UPDATE_ITEM_BANKS_FAILURE:
      return {
        ...state,
        itemBanksUpdateError: action.error,
        isUpdatingItemBanks: false
      }

    case lessonConstants.LESSON_ITEM_BANK_REQ:
      return {
        ...state,
        isFetchingItemBank: true
      }

    case lessonConstants.LESSON_ITEM_BANK_SUCCESS:
      return {
        ...state,
        isFetchingItemBank: false,
        lessonItemBank: action.itemBank,
        lessonItems: action.lessonItems
      }

    case lessonConstants.LESSON_ITEM_BANK_FAILURE:
      return {
        ...state,
        itemBanksFetchError: action.error,
        isFetchingItemBank: false
      }

    case lessonConstants.SAVE_ITEMS_TO_BANK:
      return {
        ...state,
        isSavingItemsToBank: true
      }

    case lessonConstants.SAVE_ITEMS_TO_BANK_SUCCESS:
      return {
        ...state,
        isSavingItemsToBank: false,
        lessonItemBank: action.itemBank,
        lessonItems: action.lessonItems
      }

    case lessonConstants.SAVE_ITEMS_TO_BANK_FAILURE:
      return {
        ...state,
        itemBankItemsSaveError: action.error,
        isSavingItemsToBank: false
      }

    case lessonConstants.SORT_ITEMS_IN_BANK:
      return {
        ...state,
        isSortingItemBank: true
      }

    case lessonConstants.SORT_ITEMS_IN_BANK_SUCCESS:
      return {
        ...state,
        isSortingItemBank: false,
        lessonItemBank: action.itemBank
      }

    case lessonConstants.SORT_ITEMS_IN_BANK_FAILURE:
      return {
        ...state,
        itemBankSortError: action.error,
        isSortingItemBank: false
      }

    case lessonConstants.DELETE_ITEMS_FROM_BANK:
      return {
        ...state,
        isDeletingItemBank: action.key
      }

    case lessonConstants.DELETE_ITEMS_FROM_BANK_SUCCESS:
      return {
        ...state,
        isDeletingItemBank: false,
        lessonItemBank: action.itemBank,
        lessonItems: action.lessonItems
      }

    case lessonConstants.DELETE_ITEMS_FROM_BANK_FAILURE:
      return {
        ...state,
        itemBankDeleteError: action.error,
        isDeletingItemBank: false
      }

    case lessonConstants.VIDEO_LINK_UPDATE:
      return {
        ...state,
        isChangingVideoLink: true
      }

    case lessonConstants.VIDEO_LINK_UPDATE_SUCCESS:
      return {
        ...state,
        isChangingVideoLink: false,
        lesson: action.lesson
      }

    default:
      return state
  }
}
